export const updateAccountMini = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      lotNumberPrefix
      defaultWeightUOM
      paymentTermId
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
      }
      # contacts {
      #   name
      #   email
      #   phone
      #   description
      # }
      # billingContacts {
      #   name
      #   email
      #   phone
      #   description
      # }
      billingEmail
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      verifyInboundRailCar
      trackInboundSeals
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      # attachments {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      # bolTemplate {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      # receiptTemplate {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      # services {
      #   items {
      #     id
      #     owner
      #     groups
      #     active
      #     status
      #     name
      #     description
      #     unit
      #     pcs
      #     car
      #     tl
      #     mbf
      #     lf
      #     sf
      #     sqm
      #     gal
      #     l
      #     lbs
      #     tn
      #     cwt
      #     kg
      #     mt
      #     accountName
      #     accountId
      #     reloadYardId
      #     createdAt
      #     updatedAt
      #   }
      #   nextToken
      # }
      # checklists {
      #   items {
      #     id
      #     owner
      #     groups
      #     active
      #     reloadYardId
      #     resourceId
      #     name
      #     description
      #     processName
      #     reloadYardCommodityId
      #     createdBy
      #     createdAt
      #     updatedAt
      #   }
      #   nextToken
      # }
      createdAt
      updatedAt
    }
  }
`;

// export const createInboundShipmentId = /* GraphQL */ `
//   mutation CreateInboundShipment(
//     $input: CreateInboundShipmentInput!
//     $condition: ModelInboundShipmentConditionInput
//   ) {
//     createInboundShipment(input: $input, condition: $condition) {
//       id
//     }
//   }
// `;

// export const deleteInboundShipmentMini = /* GraphQL */ `
//   mutation DeleteInboundShipment(
//     $input: DeleteInboundShipmentInput!
//     $condition: ModelInboundShipmentConditionInput
//   ) {
//     deleteInboundShipment(input: $input, condition: $condition) {
//       id
//     }
//   }
// `;
